import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    Output,
    QueryList,
    ViewChildren
} from "@angular/core";
import {Subscription} from "rxjs";
import {TranslateService} from "ng2-translate";
import {Headers, Http} from "@angular/http";
import {ResponsiveService} from "../../../orchestration/responsive.service";
import {DecimalFieldComponent} from "../../../inputs/decimal-field/decimal-field.component";
import {AbstractField} from "../../../inputs/field/abstract-field";
import {NgModel} from "@angular/forms";
import {AbstractModelContainer} from "../../../inputs/form/form.component";
import {PaymentModel} from "../../payment.model";
import {CardPaymentSubmissionResult, PaymentAuthorisationType, PaymentCard} from "../../payment";

@Component({
    selector: "woa-stripe-scanned-payment-card-panel",
    templateUrl: "./stripe-scanned-payment-card-panel.component.html",
    providers: [
        {provide: AbstractModelContainer, useExisting: StripeScannedPaymentCardPanelComponent},
        {provide: PaymentCard, useExisting: StripeScannedPaymentCardPanelComponent}
    ]
})
export class StripeScannedPaymentCardPanelComponent extends PaymentCard implements OnDestroy {
    @Input() disabled: boolean = false;
    @Input() cardNumber: string = "4242 4242 4242 4242";

    @Output() onChangeCard: EventEmitter<void> = new EventEmitter<void>();

    @ViewChildren(NgModel) private models: QueryList<NgModel>;

    DecimalFieldComponent = DecimalFieldComponent;

    cardExpMonth: string;
    cardExpYear: string;
    cardCvc: string;

    private _cardExpiry: string = "12/22";
    private subscriptions: Subscription = new Subscription();

    constructor(private changeDetectorRef: ChangeDetectorRef,
                private responsiveService: ResponsiveService,
                private translate: TranslateService,
                private elementRef: ElementRef,
                private http: Http,
                private paymentModel: PaymentModel) {
        super();
    }

    @Input()
    get cardExpiry(): string {
        return this._cardExpiry;
    }

    set cardExpiry(cardExpiry: string) {
        this._cardExpiry = cardExpiry;
        if (this._cardExpiry) {
            this.cardExpMonth = this._cardExpiry.split("/")[0];
            this.cardExpYear = this._cardExpiry.split("/")[1];
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    getModels(): QueryList<NgModel> {
        return this.models;
    }

    isValid(): boolean {
        return true;
    }

    markAsUnsubmitted(): void {
    }

    async submit(): Promise<CardPaymentSubmissionResult> {
        const data = await this.createCardToken(this.cardNumber, this.cardExpMonth, this.cardExpYear, this.cardCvc);
        return new CardPaymentSubmissionResult(PaymentAuthorisationType.STRIPE_CARD_TOKEN, data.id, data.card.brand, undefined, data.card.last4);
    }

    canSavePaymentDetails(): boolean {
        return false;
    }

    monthChanged(yearInput: HTMLElement) {
        if (this.cardExpMonth.length === 2) {
            yearInput.focus();
        }
    }

    yearChanged(cvcField: AbstractField) {
        if (this.cardExpYear.length === 2) {
            cvcField.focus();
        }
    }

    private async createCardToken(cardNumber: string, cardExpMonth: string, cardExpYear: string, cardCvc: string): Promise<any> {
        try {
            const data = await this.http.post("https://api.stripe.com/v1/tokens", undefined, {
                params: {
                    "card[number]": cardNumber,
                    "card[exp_month]": cardExpMonth,
                    "card[exp_year]": cardExpYear,
                    "card[cvc]": cardCvc
                },
                headers: new Headers({
                    Authorization: "Bearer " + this.paymentModel.paymentPlatformPublicKey
                })
            }).toPromise();

            return data.json();
        } catch (error) {
            // noinspection JSUnresolvedReference
            if (error._body) {
                // noinspection JSUnresolvedReference
                const body: any = JSON.parse(error._body);
                if (body.error && body.error.message) {
                    throw new Error(body.error.message);
                }
            }
            throw error;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/payment/card-payment/stripe-scanned-payment-card-panel/stripe-scanned-payment-card-panel.component.ts